declare var window: any;

const InvoiceForm = {
  currentFormQuery: null,
  setSelectListener(this: any, selector: string) {
    const element = document.querySelector(selector);

    element?.addEventListener("change", () => {
      element.dispatchEvent(new Event("input", { bubbles: true }));
    });
  },
  mounted(this: any) {
    this.setSelectListener("#invoice-form_vessel_id", "vessel_id");
    this.setSelectListener("#invoice-form_currency_code", "currency_code");
    this.setSelectListener("#invoice-form_payment_terms", "payment_terms");
    this.handleEvent("select_option", ({ id, option }: any) => {
      const element = <HTMLInputElement>document.querySelector(`#${id}`);
      if (element) {
        element.value = option;
        element.dispatchEvent(new Event("change"));
      }
    });
    this.handleEvent("verify_form_changes", () => {
      let changed: any = {};
      this.currentFormQuery !== this.getIncomingFormQuery(this)
        ? (changed.value = true)
        : (changed.value = false);
      this.pushEvent("form_changed", changed);
    });
    this.handleEvent("save_current_form_query", () => {
      this.currentFormQuery = this.getIncomingFormQuery(this);
    });
    window.addEventListener("beforeunload", function (e: any) {
      if (document.querySelectorAll("form[phx-form-dirty]").length > 0) {
        e.preventDefault();
        e.returnValue = "";
      }
    });
  },
  reconnected(this: any) {
    const vesselId = (<HTMLInputElement>(
      document.querySelector("#invoice-form_vessel_id")
    ))?.value;
    const invoiceDate = (<HTMLInputElement>(
      document.querySelector("#invoice-form_invoice_date")
    ))?.value;
    this.pushEventTo(
      "#confirmations-table",
      "prelist_confirmations_after_reconnect",
      { vessel_id: vesselId, invoice_date: invoiceDate },
    );
  },
  getIncomingFormQuery(this: any) {
    let form = this.el.closest("form");
    let formData: any = new FormData(form);
    formData.delete("invoice[vessel_id]");
    formData.delete("invoice[invoice_date]");
    let queryString = new URLSearchParams(formData).toString();
    return queryString;
  },
};

export default InvoiceForm;
